export default __webpack_public_path__ + "static/media/about.a5aaa70b.png";